import React from "react";
// import { Link } from "react-router-dom";
import './Features.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
 

const Features = ()=> {

    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80; // Adjust according to your header height
              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: "smooth",
              });
            }
          }, 100); // Delay to ensure DOM is loaded
        }
      }, []);
      

    useEffect(() => {
      setIsClient(true);
    }, []);
  
    if (!isClient) return null;

    return (
        <>
            <AIheader/>

 

            {/* START techBannerMain */}
            <section className='techBannerMain'>
                <div className='container'>
                    <div className='techBannerOuter'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                                <div className='techBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="rent id"/> Features</h1>
                                    <p>Rental workflows<br/> and tools.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END techBannerMain */}
 
            <section className="featuresTabPageMain featuresTabDesktopMain">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <ul className="nav nav-tabs">
                                    <li className="nav-item">
                                        <a className="nav-link active" data-bs-toggle="tab" href="#operational">Operational</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#logistical">Logistical</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#administrative">Administrative</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#back_office">Back Office</a>
                                    </li>
                                </ul>
                            
                                <div className="tab-content">
                                    <div className="tab-pane active" id="operational">
                                        <div className='row'>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#SmartBookingManagement">
                                                        <img className='img-fluid' src="/img/feature-oper-nine.svg" alt="rent id"/>
                                                        <h3>Smart Booking <br/>Management</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentshield#GuestProtectionPlans">
                                                        <img className='img-fluid' src="/img/feature-oper-eight.svg" alt="rent id"/>
                                                        <h3>Guest Protection <br/>Plans</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#marketing_main">
                                                    <img className='img-fluid' src="/img/feature-oper-seven.svg" alt="rent id"/>
                                                    <h3>Guest Quotes</h3>
                                                </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#tabMarketing_2">
                                                        <img className='img-fluid' src="/img/feature-oper-six.svg" alt="rent id"/>
                                                        <h3>Discount Codes</h3>
                                                    </a>
                                                </div>
                                            </div>

                                            {/* START 2 */}
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#tabMarketing_3">
                                                        <img className='img-fluid' src="/img/feature-oper-five.svg" alt="rent id"/>
                                                        <h3>Promotional <br/>Spotlight</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#FleetManagementCenter">
                                                        <img className='img-fluid' src="/img/feature-oper-four.svg" alt="rent id"/>
                                                        <h3>Booking Calendar</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentsuccess#onRentGuidelines_2">
                                                        <img className='img-fluid' src="/img/feature-oper-three.svg" alt="rent id"/>
                                                        <h3>Direct <br/>Communication</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#fleettab3">
                                                        <img className='img-fluid' src="/img/feature-oper-two.svg" alt="rent id"/>
                                                        <h3>Vehicle Profile</h3>
                                                    </a>
                                                </div>
                                            </div>

                                            {/* START 3 */}
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentsuccess#rentalSupportAgent">
                                                        <img className='img-fluid' src="/img/feature-oper-one.svg" alt="rent id"/>
                                                        <h3>Rental Support<br/> Agent</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            {/* END 3 */}
                                
                                        </div>
                                    </div>
                            
                                    <div className="tab-pane fade" id="logistical">
                                        <div className='row'>
                            
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#fleettab2">
                                                        <img className='img-fluid' src="/img/feature-logist-icon-one.svg" alt="rent id"/>
                                                        <h3>Fleet <br/>Management</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/primary-commericial#onRentMain">
                                                        <img className='img-fluid' src="/img/feature-logist-icon-two.svg" alt="rent id"/>
                                                        <h3>On-Rent Coverage</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                <a href="/primary-commericial#offRentInsuranceMain">
                                                    <img className='img-fluid' src="/img/feature-logist-icon-three.svg" alt="rent id"/>
                                                    <h3>Off-Rent Coverage</h3>
                                                </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#fleettab4">
                                                        <img className='img-fluid' src="/img/feature-logist-icon-four.svg" alt="rent id"/>
                                                        <h3>Telematics </h3>
                                                    </a>
                                                </div>
                                            </div>

                                            {/* START 2 */}
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentshield#NationalRoadsideAssistance">
                                                        <img className='img-fluid' src="/img/feature-logist-icon-six.svg" alt="rent id"/>
                                                        <h3>National Roadside  <br/>Assistance</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentsuccess#tolls_and_tickets">
                                                        <img className='img-fluid' src="/img/feature-logist-icon-seven.svg" alt="rent id"/>
                                                        <h3>Tolls<br/> & Tickets</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/primary-commericial#PersonalRental">
                                                        <img className='img-fluid' src="/img/feature-logist-icon-nine.svg" alt="rent id"/>
                                                        <h3>Personal & <br/>Leisure Rental</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/primary-commericial#GigRental">
                                                        <img className='img-fluid' src="/img/feature-logist-icon-eight.svg" alt="rent id"/>
                                                        <h3>Gig<br/> Rental</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            {/* END 3 */}
                                
                                        </div>
                                    </div>




                                    <div className="tab-pane fade" id="administrative">
                                        <div className='row'>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rent-id#guestverification">
                                                        <img className='img-fluid' src="/img/feature-admin-two.svg" alt="rent id"/>
                                                        <h3>Realtime Guest <br/>Verification</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rent-id#AutoInsuranceValidation">
                                                        <img className='img-fluid' src="/img/feature-admin-one.svg" alt="rent id"/>
                                                        <h3>Auto Insurance <br/>Validation</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                <a href="/rent-id#DriverIQScore">
                                                    <img className='img-fluid' src="/img/feature-admin-three.svg" alt="rent id"/>
                                                    <h3>DriverIQ <br/> Score</h3>
                                                </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#customerRelationship_1">
                                                        <img className='img-fluid' src="/img/feature-admin-four.svg" alt="rent id"/>
                                                        <h3>Review <br/>Management </h3>
                                                    </a>
                                                </div>
                                            </div>

                                            {/* START 2 */}
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#customerRelationship_3">
                                                        <img className='img-fluid' src="/img/feature-admin-five.svg" alt="rent id"/>
                                                        <h3>Schedule <br/>Messages</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentshield#CoverageSettings">
                                                        <img className='img-fluid' src="/img/feature-admin-six.svg" alt="rent id"/>
                                                        <h3>Coverage <br/>Settings</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#financialManagements_1">
                                                        <img className='img-fluid' src="/img/feature-admin-seven.svg" alt="rent id"/>
                                                        <h3>Dynamic <br/>Invoices</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#financialManagements_2">
                                                        <img className='img-fluid' src="/img/feature-admin-eight.svg" alt="rent id"/>
                                                        <h3>Dynamic <br/> Agreement</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            {/* END */}
                                
                                        </div>
                                    </div>

                                    <div className="tab-pane fade" id="back_office">
                                        <div className='row align-items-center'>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentsuccess#refundpolicy">
                                                        <img className='img-fluid' src="/img/feature-office-icon-one.svg" alt="rent id"/>
                                                        <h3>Refund  <br/>Process</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentsuccess#violations">
                                                        <img className='img-fluid' src="/img/feature-office-icon-two.svg" alt="rent id"/>
                                                        <h3>Renter <br/>Violations</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                <a href="/rentsuccess#insurance_claims">
                                                    <img className='img-fluid' src="/img/feature-office-icon-three.svg" alt="rent id"/>
                                                    <h3>Insurance  <br/> Claims</h3>
                                                </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentsuccess#guest_behaviors">
                                                        <img className='img-fluid' src="/img/feature-office-icon-four.svg" alt="rent id"/>
                                                        <h3>Report <br/>Guests </h3>
                                                    </a>
                                                </div>
                                            </div>

                                            {/* START 2 */}
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#financialManagements_3">
                                                        <img className='img-fluid' src="/img/feature-office-icon-five.svg" alt="rent id"/>
                                                        <h3>Payment <br/>Methods</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentshield#DigitalClaimsManagement">
                                                        <img className='img-fluid' src="/img/feature-office-icon-six.svg" alt="rent id"/>
                                                        <h3>Digital Claims <br/>Management</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentdirect#AnalyticsReporting">
                                                        <img className='img-fluid' src="/img/feature-office-icon-seven.svg" alt="rent id"/>
                                                        <h3>Analytics & Reporting</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rent-id#NationalBlockListDatabase">
                                                        <img className='img-fluid' src="/img/feature-office-icon-eight.svg" alt="rent id"/>
                                                        <h3>National BlockList <br/> Database</h3>
                                                    </a>
                                                </div>
                                            </div>

                                            {/* START 3 */}
                                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                                <div className='featuresTabPageInner'>
                                                    <a href="/rentsuccess#CancellationPolicies">
                                                        <img className='img-fluid' src="/img/feature-office-icon-nine.svg" alt="rent id"/>
                                                        <h3>Cancellation Policy</h3>
                                                    </a>
                                                </div>
                                            </div>
                                            {/* END */}
                                    
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
            </section>

            <section className="featuresTabPageMain featuresTabMobileMain">
                <div className="container">
                    <div className="row justify-content-center">
                        {/* <Accordion defaultActiveKey="0"> */}
                        <Accordion>
                            {/* start 1 */}
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    Operational
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#SmartBookingManagement">
                                                    <img className='img-fluid' src="/img/feature-oper-nine.svg" alt="rent id"/>
                                                    <h3>Smart Booking <br/>Management</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentshield#GuestProtectionPlans">
                                                    <img className='img-fluid' src="/img/feature-oper-eight.svg" alt="rent id"/>
                                                    <h3>Guest Protection <br/>Plans</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                            <a href="/rentdirect#marketing_main">
                                                <img className='img-fluid' src="/img/feature-oper-seven.svg" alt="rent id"/>
                                                <h3>Guest Quotes</h3>
                                            </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#tabMarketing_2">
                                                    <img className='img-fluid' src="/img/feature-oper-six.svg" alt="rent id"/>
                                                    <h3>Discount Codes</h3>
                                                </a>
                                            </div>
                                        </div>

                                        {/* START 2 */}
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#tabMarketing_3">
                                                    <img className='img-fluid' src="/img/feature-oper-five.svg" alt="rent id"/>
                                                    <h3>Promotional <br/>Spotlight</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#FleetManagementCenter">
                                                    <img className='img-fluid' src="/img/feature-oper-four.svg" alt="rent id"/>
                                                    <h3>Booking Calendar</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentsuccess#OnRentGuidelines">
                                                    <img className='img-fluid' src="/img/feature-oper-three.svg" alt="rent id"/>
                                                    <h3>Direct <br/>Communication</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#fleettab3">
                                                    <img className='img-fluid' src="/img/feature-oper-two.svg" alt="rent id"/>
                                                    <h3>Vehicle Profile</h3>
                                                </a>
                                            </div>
                                        </div>

                                        {/* START 3 */}
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentsuccess#rentalSupportAgent">
                                                    <img className='img-fluid' src="/img/feature-oper-one.svg" alt="rent id"/>
                                                    <h3>Rental Support<br/> Agent</h3>
                                                </a>
                                            </div>
                                        </div>
                                        {/* END 3 */}
                            
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* start 2 */}
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    Logistical
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#fleettab2">
                                                    <img className='img-fluid' src="/img/feature-logist-icon-one.svg" alt="rent id"/>
                                                    <h3>Fleet <br/>Management</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/primary-commericial#onRentMain">
                                                    <img className='img-fluid' src="/img/feature-logist-icon-two.svg" alt="rent id"/>
                                                    <h3>On-Rent Coverage</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                            <a href="/primary-commericial#offRentInsuranceMain">
                                                <img className='img-fluid' src="/img/feature-logist-icon-three.svg" alt="rent id"/>
                                                <h3>Off-Rent Coverage</h3>
                                            </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#fleettab4">
                                                    <img className='img-fluid' src="/img/feature-logist-icon-four.svg" alt="rent id"/>
                                                    <h3>Telematics </h3>
                                                </a>
                                            </div>
                                        </div>

                                        {/* START 2 */}
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentshield#NationalRoadsideAssistance">
                                                    <img className='img-fluid' src="/img/feature-logist-icon-six.svg" alt="rent id"/>
                                                    <h3>National Roadside  <br/>Assistance</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentsuccess#tolls_and_tickets">
                                                    <img className='img-fluid' src="/img/feature-logist-icon-seven.svg" alt="rent id"/>
                                                    <h3>Tolls<br/> & Tickets</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/primary-commericial#PersonalRental">
                                                    <img className='img-fluid' src="/img/feature-logist-icon-nine.svg" alt="rent id"/>
                                                    <h3>Personal & <br/>Leisure Rental</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/primary-commericial#GigRental">
                                                    <img className='img-fluid' src="/img/feature-logist-icon-eight.svg" alt="rent id"/>
                                                    <h3>Gig<br/> Rental</h3>
                                                </a>
                                            </div>
                                        </div>
                                        {/* END 3 */}
                            
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* start 3 */}
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    Administrative
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rent-id#guestverification">
                                                    <img className='img-fluid' src="/img/feature-admin-two.svg" alt="rent id"/>
                                                    <h3>Realtime Guest <br/>Verification</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rent-id#AutoInsuranceValidation">
                                                    <img className='img-fluid' src="/img/feature-admin-one.svg" alt="rent id"/>
                                                    <h3>Auto Insurance <br/>Validation</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                            <a href="/rent-id#DriverIQScore">
                                                <img className='img-fluid' src="/img/feature-admin-three.svg" alt="rent id"/>
                                                <h3>DriverIQ <br/> Score</h3>
                                            </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#customerRelationship_1">
                                                    <img className='img-fluid' src="/img/feature-admin-four.svg" alt="rent id"/>
                                                    <h3>Review <br/>Management </h3>
                                                </a>
                                            </div>
                                        </div>

                                        {/* START 2 */}
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#customerRelationship_3">
                                                    <img className='img-fluid' src="/img/feature-admin-five.svg" alt="rent id"/>
                                                    <h3>Schedule <br/>Messages</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentshield#CoverageSettings">
                                                    <img className='img-fluid' src="/img/feature-admin-six.svg" alt="rent id"/>
                                                    <h3>Coverage <br/>Settings</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#financialManagements_1">
                                                    <img className='img-fluid' src="/img/feature-admin-seven.svg" alt="rent id"/>
                                                    <h3>Dynamic <br/>Invoices</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#financialManagements_2">
                                                    <img className='img-fluid' src="/img/feature-admin-eight.svg" alt="rent id"/>
                                                    <h3>Dynamic <br/> Agreement</h3>
                                                </a>
                                            </div>
                                        </div>
                                        {/* END */}
                            
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* start 4 */}
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    Back Office
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentsuccess#refundpolicy">
                                                    <img className='img-fluid' src="/img/feature-office-icon-one.svg" alt="rent id"/>
                                                    <h3>Refund  <br/>Process</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentsuccess#violations">
                                                    <img className='img-fluid' src="/img/feature-office-icon-two.svg" alt="rent id"/>
                                                    <h3>Renter <br/>Violations</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                            <a href="/rentsuccess#insurance_claims">
                                                <img className='img-fluid' src="/img/feature-office-icon-three.svg" alt="rent id"/>
                                                <h3>Insurance  <br/> Claims</h3>
                                            </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentsuccess#guest_behaviors">
                                                    <img className='img-fluid' src="/img/feature-office-icon-four.svg" alt="rent id"/>
                                                    <h3>Report <br/>Guests </h3>
                                                </a>
                                            </div>
                                        </div>

                                        {/* START 2 */}
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#financialManagements_3">
                                                    <img className='img-fluid' src="/img/feature-office-icon-five.svg" alt="rent id"/>
                                                    <h3>Payment <br/>Methods</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentshield#DigitalClaimsManagement">
                                                    <img className='img-fluid' src="/img/feature-office-icon-six.svg" alt="rent id"/>
                                                    <h3>Digital Claims <br/>Management</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentdirect#AnalyticsReporting">
                                                    <img className='img-fluid' src="/img/feature-office-icon-seven.svg" alt="rent id"/>
                                                    <h3>Analytics & Reporting</h3>
                                                </a>
                                            </div>
                                        </div>
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rent-id#NationalBlockListDatabase">
                                                    <img className='img-fluid' src="/img/feature-office-icon-eight.svg" alt="rent id"/>
                                                    <h3>National BlockList <br/> Database</h3>
                                                </a>
                                            </div>
                                        </div>

                                        {/* START 3 */}
                                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                                            <div className='featuresTabPageInner'>
                                                <a href="/rentsuccess#CancellationPolicies">
                                                    <img className='img-fluid' src="/img/feature-office-icon-nine.svg" alt="rent id"/>
                                                    <h3>Cancellation Policy</h3>
                                                </a>
                                            </div>
                                        </div>
                                        {/* END */}
                                
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* END 4 */}
                    
                        </Accordion>
                    </div>
                </div>
            </section>
   
            <Footer/>
        </>
    )
}

export default Features;